@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.legalText {
    text-align: center;
    color: var(--color-black);
    border-top: 1px solid var(--color-silver);
    padding-top: 1.875rem;
    margin-top: 0.625rem;
    line-height: 1.5;
    font-size: 0.75rem;

    @include breakpoint.breakpoint(layout.$aboveLargeLine) {
        width: 100%;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        border-top: none;
    }

    & a {
        color: var(--color-lobster);
        text-decoration: underline;
    }

    & input {
        border: none;
        box-shadow: none;
    }
}
